import CheckIcon from '@mui/icons-material/Check'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'

import { MDVIP_INVOICE_SLOGAN, UTMData } from '../Constants'
import { push_pageview } from '../service/analytics'
import { invoice, reset } from '../store'
import IDForm from './Forms/IDForm'
import InvoiceForm from './Forms/InvoiceForm'
import OtherForm from './Forms/OtherForm'
import Navigation from './misc/Navigation'

const SloganProvider: React.FC<{ isInvoice: boolean }> = ({ isInvoice }) => {
  const [slogan, setSlogan] = useState('')
  const location = useLocation()

  useEffect(() => {
    if (isInvoice && location.pathname === '/') {
      setSlogan(MDVIP_INVOICE_SLOGAN)
    } else {
      setSlogan('')
    }
  }, [isInvoice, location.pathname])

  return <div className="slogan mobile-tablet">{slogan}</div>
}
const VerifyAccount: React.FC = () => {
  const dispatch = useDispatch()

  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const [isInvoice, setIsInvoice] = useState(false)

  useEffect(() => {
    push_pageview({ page_id: 'express_pay_verify_account', page_name: 'Verify Account' })
    const params = new URLSearchParams(window.location.search)
    const UTM_Source__c = params.get('utm_source') || params.get('mdvip_source') || 'direct'
    const UTM_Medium__c = params.get('utm_medium') || params.get('mdvip_medium') || 'none'
    const UTM_Campaign__c = params.get('utm_campaign') || params.get('mdvip_campaign') || ''
    const Source_URL__c = location.href || 'https://www.mdvip.com/pay?undefined'

    const UTMValues: UTMData = {
      Source_URL__c: Source_URL__c,
      Web_MD_Domain__c: Source_URL__c,
      UTM_Campaign__c: UTM_Campaign__c,
      UTM_Medium__c: UTM_Medium__c,
      UTM_Source__c: UTM_Source__c,
      UTM_Term__c: params.get('utm_term') || params.get('mdvip_term'),
    }

    // @todo move mdvip_ep_customer_data to redux store.
    window.sessionStorage.removeItem('mdvip_ep_customer_data')
    const mdvip_ep_customer_data = JSON.stringify(UTMValues)
    window.sessionStorage.setItem('mdvip_ep_customer_data', mdvip_ep_customer_data)

    const documentId = params.get('doc_id')
    const clientId = params.get('id')

    // Enable Invoice Flow.
    if (
      documentId &&
      clientId &&
      /^[0-9]+$/.test(documentId) && // Ensure documentId is alphanumeric.
      /^[a-zA-Z0-9]+$/.test(clientId) && // Ensure clientId is alphanumeric.
      clientId.length == 18 // Ensure clientId is alphanumeric.
    ) {
      // It is the invoice Flow
      dispatch(invoice({ documentId: documentId.toString().trim(), clientId: clientId.toString().trim() }))
      setSelectedTabIndex(2)
      setIsInvoice(true)
    } else {
      setIsInvoice(false)
      dispatch(reset())
    }
  }, [])

  return (
    <div className="page-verify-account form-content">
      <Navigation activeIndex={0} />
      <div className="main-content">
        <h1>Verify Account</h1>
        <SloganProvider isInvoice={isInvoice} />
        <div className="content">
          <div className="options">
            <Tabs selectedIndex={selectedTabIndex} onSelect={(index) => setSelectedTabIndex(index)}>
              <TabList>
                <Tab disabled={isInvoice}>
                  <CheckIcon />
                  MDVIP Id
                </Tab>
                <Tab disabled={isInvoice}>
                  <CheckIcon />
                  Invoice #
                </Tab>
                <Tab>
                  <CheckIcon />
                  Other
                </Tab>
              </TabList>
              <TabPanel disabled={isInvoice}>
                <IDForm />
              </TabPanel>
              <TabPanel disabled={isInvoice}>
                <InvoiceForm />
              </TabPanel>
              <TabPanel>
                <OtherForm />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VerifyAccount
